import React from 'react';
import Geosuggest from 'react-geosuggest';
import Select from '../../../commonComponents/util/Select';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import GeoSuggestWrapper from '../../../commonComponents/shared/GeoSuggestWrapper';
import FadeOutErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';

import { deepEquals, concatenateGeosuggestLabel  } from '../../../../lib/utils';

export default class ReturnAddress extends React.Component {
    constructor(props) {
        super(props);
        const initialAddress = {
            streetNumber: this.props.address.streetNumber || '',
            street: this.props.address.street || '',
            apartment: this.props.address.apartment || '',
            unitType: this.props.address.unitType || '',
            city: this.props.address.city || '',
            state: this.props.address.state || '',
            zip: this.props.address.zip || '',
            country: this.props.address.country || ''
        };

        this.state = {
            initialAddress,
            address: initialAddress,
            noSuggestionsError: false,
            invalidAddressError: false,
            addressLabel: this.props.addressLabel || '',
            error: false,
        };

        this.clearNoSuggestions = this.clearNoSuggestions.bind(this);
        this.updateSuggestions = this.updateSuggestions.bind(this);
        this.noSuggestions = this.noSuggestions.bind(this);
        this.onSuggestSelect = this.onSuggestSelect.bind(this);
        this.updateErrors = this.updateErrors.bind(this);
    }

    noSuggestionsError = 'noSuggestionsError';
    invalidAddressError = 'invalidAddressError';

    componentWillReceiveProps(nextProps) {
        const address = { ...nextProps.address };
        delete address.isManual;
        if (!deepEquals(address, this.state.initialAddress) && !deepEquals(nextProps.address, {})) {
            this.setState({ address, initialAddress: address, addressLabel: nextProps.addressLabel });
        }
    }


    clearNoSuggestions() {
        if (this.state.noSuggestionsError) this.updateErrors(this.noSuggestionsError, false);
        if (this.state.invalidAddressError) {
            this.updateErrors(this.invalidAddressError, false);
        }
    }

    updateSuggestions(suggestions) {
        if (suggestions.length && this.state.addressLabel) this.clearNoSuggestions();
    }

    noSuggestions() {
        if (this._geoSuggest.props.value !== '') {
            this.updateErrors(this.noSuggestionsError, true);
        }
    }

    onBlur() {
        if ((deepEquals(this.state.address, {}) || deepEquals({
            streetNumber: this.state.address.streetNumber,
            street: this.state.address.street,
            city: this.state.address.city,
            state: this.state.address.state,
            zip: this.state.address.zip,
            country: this.state.address.country
        }, {
                streetNumber: '', street: '', city: '', state: '', zip: '', country: ''
            })) && this.state.addressLabel && !this.state.noSuggestionsError) {
            this.updateErrors(this.invalidAddressError, true);
        } else if (this.state.invalidAddressError) {
            this.updateErrors(this.invalidAddressError, false);
        }
    }


    updateAddressLabel(e) {
        this.setState({ addressLabel: e, address: { ...this.state.address, streetNumber: '', street: '', city: '', state: '', zip: '', country: '' } })
        if (!e) this.clearNoSuggestions();
    }

    onSuggestSelect(suggestion) {
        if (suggestion && suggestion.gmaps && suggestion.gmaps.address_components) {
            let { address_components } = suggestion.gmaps;
            let address = { ...this.state.address };
            address.streetNumber = address_components.find(obj => obj.types.includes('street_number')) ? address_components.find(obj => obj.types.includes('street_number')).long_name : '';
            address.street = address_components.find(obj => obj.types.includes('route')) ? address_components.find(obj => obj.types.includes('route')).long_name : '';
            address.city = address_components.find(obj => obj.types.includes('locality')) ? address_components.find(obj => obj.types.includes('locality')).long_name : '' || address_components.find(obj => obj.types.includes('sublocality')) ? address_components.find(obj => obj.types.includes('sublocality')).long_name : '';
            address.state = address_components.find(obj => obj.types.includes('administrative_area_level_1')) ? address_components.find(obj => obj.types.includes('administrative_area_level_1')).long_name : '';
            address.country = address_components.find(obj => obj.types.includes('country')) ? address_components.find(obj => obj.types.includes('country')).long_name : '';
            address.zip = address_components.find(obj => obj.types.includes('postal_code')) ? address_components.find(obj => obj.types.includes('postal_code')).long_name : '';
            if (!address.streetNumber || !address.street) {
                this.updateErrors(this.invalidAddressError, true);
                //set address to empty object and return
                this.setState({ addressLabel: concatenateGeosuggestLabel(address, false), address: { ...this.state.address, streetNumber: '', street: '', city: '', state: '', zip: '', country: '' } });
                this._geoSuggest.blur();
                return;
            } else if (this.state.invalidAddressError) {
                this.updateErrors(this.invalidAddressError, false);
            }
            this.setState({ address, addressLabel: concatenateGeosuggestLabel(address)});
            this._geoSuggest.blur();
        }
    }

    updateAddressComponent(e) {
        this.setState({ address: { ...this.state.address, [e.target.name]: e.target.value } });
    }

    updateErrors(errorName, value) {
        if ((errorName === this.invalidAddressError && !this.state.noSuggestionsError) || errorName === this.noSuggestionsError) {
            this.setState({ [errorName]: value });
        }
    }

    async apply() {
        this.setState({ error: false });
        await this.props.update({ ...this.state.address, isManual: false });
        if (!this.props.success) {
            this.setState({ error: true });
        }
    }

    cancel() {
        const address = { ...this.props.address };
        delete address.isManual;
        this.setState({ initialAddress: address, address: address, error: false, addressLabel: concatenateGeosuggestLabel(address, false) });
    }


    render() {
        const validationErr = this.state.noSuggestionsError || this.state.invalidAddressError;
        return (
            <GeoSuggestWrapper isIsraeli={false}>
                <div className="address-autocomplete">
                    <div>
                        <label className={`input-label ${validationErr ? "error-label" : ""}`}>Return Address</label>
                        <Geosuggest inputClassName={validationErr ? "error-input" : ""}
                            placeholder="Enter Address" queryDelay={0} autoComplete={'on'}
                            ref={el => this._geoSuggest = el} value={this.state.addressLabel}
                            onUpdateSuggests={this.updateSuggestions}
                            onChange={this.updateAddressLabel.bind(this)}
                            onBlur={this.onBlur.bind(this)}
                            initialValue={this.state.addressLabel}
                            onFocus={this.clearNoSuggestions} onSuggestSelect={this.onSuggestSelect}
                            types={['address']} onSuggestNoResults={this.noSuggestions} />
                        <FadeOutErrorMessage show={this.state.noSuggestionsError} message="No suggestions, use address not found." />
                        <FadeOutErrorMessage show={this.state.invalidAddressError} message="Invalid Address" />
                    </div>
                    <div>
                        <label className="input-label input-label-small">Unit Type</label>
                        <Select clearable={true}
                            options={this.props.unitTypes}
                            name="unitType" value={this.state.address.unitType ? this.state.address.unitType : ''}
                            onChange={this.updateAddressComponent.bind(this)} />
                    </div>
                    <div>
                        <label className="input-label input-label-small">Unit #</label>
                        <input type="text" value={this.state.address.apartment || ''}
                            onChange={this.updateAddressComponent.bind(this)} name="apartment" />
                    </div>
                    {!deepEquals(this.state.initialAddress, this.state.address) && <div className="settings-btns">
                        {this.props.loading ?
                            <LoadingSpinner height={20} loading={this.props.loading} /> :
                            <div>
                                <button className="btn btn-small btn-primary icon-left" disabled={validationErr} onClick={this.apply.bind(this)}>Apply</button>
                                <button className="btn btn-small btn-accent" onClick={this.cancel.bind(this)}>Cancel</button>
                                <FadeOutErrorMessage show={this.state.error}/>
                            </div>}
                    </div>}
                </div>
            </GeoSuggestWrapper>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/paymentSettings/ReturnAddress.jsx